import React from 'react';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac/Enllac';
// @ts-ignore
import TornaEnrereComponent from 'components/corporatiu/TornaEnrere';
import styles from './memoriamarato.module.scss';

const TornaEnrere = TornaEnrereComponent as React.ComponentType<{
    path: string;
    text?: string;
}>;

const Enllac = EnllacComponent as React.ComponentType<{
    href?: string;
    title?: string;
    novaFinestra?: boolean;
    children: React.ReactNode;
}>;

const IMG_HOST = 'https://img.ccma.cat';

interface MemoriaMaratoSubpaginaProps {
    anyMarato: string;
    seccio: string;
}

type SubpaginaContent = {
    titol: string;
    contingut: React.ReactNode;
};

const CONTENT: Record<string, SubpaginaContent> = {
    '2014-comunicacio': {
        titol: 'Comunicació',
        contingut: (
            <>
                <h2>tv3.cat/marato</h2>
                <p>
                    Al llarg del període que repassa aquesta memòria, la pàgina web de La Marató va registrar 258.445 visitants
                    únics i 992.242 pàgines vistes i va consolidar així la seva posició com a canal més consultat per
                    l&apos;audiència per informar-se del projecte. Només el dia de l&apos;emissió del programa, 57.293 visitants
                    únics van consultar 196.231 pàgines.
                </p>
                <h2>Xarxes socials</h2>
                <p>
                    Durant el 2014, 202.000 usuaris van seguir l&apos;actualitat de La Marató a través de la pàgina de Facebook i
                    44.200 a Twitter.
                </p>
                <h2>Revista</h2>
                <ul>
                    <li>
                        <Enllac
                            href='https://issuu.com/monmarato/docs/monmarato26'
                            title="Número 26, s'obre en finestra nova"
                            novaFinestra={true}
                        >
                            Número 26
                        </Enllac>
                    </li>
                </ul>
            </>
        )
    },
    '2014-participacio': {
        titol: 'Participació ciutadana i empresarial',
        contingut: (
            <>
                <img src={`${IMG_HOST}/multimedia/jpg/7/0/1469101330707.jpg`} alt='Imatge de voluntaris' />
                <h2>Voluntaris</h2>
                <p>
                    2.312 voluntaris van participar en l&apos;atenció dels donatius telefònics el dia de La Marató. Aquest
                    col·lectiu va estar format per representants de 28 entitats de voluntariat, així com de persones a títol
                    individual, cares conegudes dels àmbits cultural, polític, esportiu i científic català i professionals de TV3
                    i Catalunya Ràdio.
                </p>
                <h2>Altres formes de suport</h2>
                <p>
                    Els ajuntaments dels municipis catalans van renovar el seu suport a La Marató amb la penjada de pancartes als
                    carrers les setmanes prèvies al programa. També les sales i companyies teatrals es van adherir a l&apos;edició
                    2014 amb la lectura d&apos;un manifest el cap de setmana de l&apos;emissió.
                </p>
            </>
        )
    },
    '2014-recerca-en-malalties-neurodegeneratives': {
        titol: 'Impuls a la recerca en malalties neurodegeneratives. La Marató 2013',
        contingut: (
            <>
                <h2>Convocatòria de projectes</h2>
                <p>
                    El mes de febrer de 2014, la Fundació va obrir una convocatòria d&apos;ajudes a la recerca sobre malalties
                    neurodegeneratives a la qual s&apos;hi van presentar 187 projectes.
                </p>
                <h2>Procés d&apos;avaluació</h2>
                <p>
                    Els treballs candidats a rebre finançament van ser avaluats per 96 experts internacionals en malalties
                    neurodegeneratives seguint un rigorós procés d&apos;avaluació per consemblants en què es va valorar la seva
                    qualitat, metodologia, rellevància científica, sanitària i social, innovació i viabilitat. El procés va ser
                    coordinat per l&apos;Agència de Qualitat i Avaluació Sanitàries de Catalunya (AQUAS).
                </p>
                <h2>Elaboració del rànquing i decisió sobre l&apos;adjudicació d&apos;ajudes</h2>
                <p>
                    Una representació del grup d&apos;experts avaluadors es va reunir per elaborar un rànquing dels projectes més
                    ben valorats. Un cop validada aquesta llista per la Comissió Assessora Científica, el Patronat de la Fundació
                    va decidir premiar 44 projectes sobre malalties neurodegeneratives.
                </p>
                <p>
                    Els treballs els duran a terme 79 equips de recerca procedents de 54 centres d&apos;investigació de primera
                    línia. D&apos;aquesta manera, 38 institucions catalanes treballaran de forma coordinada amb 9 centres estatals
                    i 7 d&apos;internacionals. Del total de projectes finançats, 23 són unitaris i 21 coordinats entre dos o més
                    centres d&apos;investigació.
                </p>
                <p>
                    Un total de 70 científics i els seus equips dedicaran els pròxims tres anys a avançar en el coneixement, el
                    diagnòstic i el tractament de les malalties del cor, amb uns resultats que incidiran directament en la
                    qualitat i l&apos;esperança de vida de les persones afectades. Els treballs, 22 d&apos;unitaris i 21 de
                    coordinats, es desenvoluparan en 35 centres d&apos;investigació de primera línia, i establiran xarxes de
                    recerca entre equips catalans, de l&apos;estat espanyol i d&apos;àmbit internacional. Veieu quin són els{' '}
                    <Enllac href='/tv3/marato/recerca/projectes-financats' title='projectes premiats'>
                        projectes premiats
                    </Enllac>
                </p>
                <h2>Acte de lliurament d&apos;ajudes</h2>
                <img src={`${IMG_HOST}/multimedia/jpg/2/5/1469092890852.jpg`} alt="Imatge de l'acte de lliurament d'ajudes" />
                <p>
                    L&apos;acte de lliurament d&apos;ajudes investigadors premiats es va celebrar el 30 d&apos;octubre a
                    l&apos;Acadèmia de Ciències Mèdiques i de la Salut de Catalunya i de Balears i va estar conduit per Núria Solé
                    i Roger de Gràcia, presentadors de La Marató 2013. Hi van intervenir el conseller de Salut, Boi Ruiz, el
                    president de l&apos;Acadèmia de Ciències Mèdiques i de la Salut de Catalunya i de Balears, Àlvar Net, i el
                    president de la Corporació Catalana de Mitjans Audiovisuals i de la Fundació La Marató de 3Cat, Brauli Duart.
                </p>
            </>
        )
    },
    '2014-reconeixements': {
        titol: 'Reconeixements',
        contingut: (
            <>
                <p>Durant el 2014, la Fundació i La Marató de 3Cat van rebre els següents premis:</p>
                <h2>Premi Caragol d&apos;Or 2014</h2>
                <img src={`${IMG_HOST}/multimedia/jpg/2/0/1469092628102.jpg`} alt="Imatge del Premi Caragol d'Or 2014" />
                <p>
                    La Societat Gastronòmica i Cultural del Comtat d&apos;Urgell va concedir el Premi Caragol d&apos;Or 2014 a la
                    Fundació La Marató de 3Cat com a reconeixement per la trajectòria d&apos;un programa que s&apos;ha convertit
                    en la iniciativa solidària que més diners recapta del món en proporció als habitants del territori on
                    s&apos;emet. El premi reconeix també la capacitat de la iniciativa per mobilitzar i implicar la ciutadania
                    catalana.
                </p>
                <h2>Premi Artur Galceran i Granés</h2>
                <img src={`${IMG_HOST}/multimedia/jpg/4/6/1469092755964.jpg`} alt='Imatge del Premi Artur Galceran i Granés' />
                <p>
                    L&apos;edició 2013 de La Marató 2013 va ser reconeguda amb Premi Artur Galceran i Granés, que atorga la
                    Societat Catalana de Neurologia, per l&apos;acció divulgativa, de sensibilització social i d&apos;impuls a la
                    recerca sobre malalties neurodegeneratives.
                </p>
                <h2>Premi Enderrock Estrella 2014</h2>
                <img src={`${IMG_HOST}/multimedia/jpg/2/3/1469092684532.jpg`} alt='Imatge del Premi Enderrock Estrella 2014' />
                <p>
                    El disc de La Marató 2013 va rebre la primera edició del Premi Enderrock Estrella al millor esdeveniment
                    musical de l&apos;any per haver assolit una trajectòria impecable i exemplar reinterpretant en català els
                    grans èxits de tots els temps a càrrec d&apos;artistes catalans i d&apos;arreu i haver esdevingut any rere any
                    el disc més venut de la música en català i rècord mundial en un sol dia.
                </p>
                <h2>Premi Números 1 de Cadena 100</h2>
                <img src={`${IMG_HOST}/multimedia/jpg/0/1/1469092483910.jpg`} alt='Imatge del Premi Números 1 de Cadena 100' />
                <p>
                    La Marató de 3Cat va rebre el Premi Números 1 de Cadena 100 per la seva tasca solidària i humana i com a
                    exemple de servei a la societat d&apos;una televisió pública.
                </p>
            </>
        )
    },
    '2014-simposium-malalties-mentals-greus': {
        titol: '15è Simpòsium. Resultats de La Marató 2008: malalties mentals greus',
        contingut: (
            <>
                <p>
                    La Fundació va presentar els resultats dels 25 projectes de recerca sobre malalties mentals greus impulsats
                    amb fons de La Marató 2008 en el marc del 15è Simpòsium, celebrat a l&apos;Institut d&apos;Estudis Catalans.
                    Els científics que van dur a terme les investigacions finançades per La Marató hi van exposar els avenços
                    assolits en el coneixement, el diagnòstic i el tractament de les malalties mentals greus. La jornada
                    científica va tenir lloc el 26 de juny.
                </p>
                <p>
                    Amb l&apos;objectiu d&apos;obrir l&apos;acte científic al públic general, el simpòsium va acollir diverses
                    accions de divulgació científica i social entorn a La Marató. D&apos;aquesta manera, s&apos;hi va inaugurar la
                    primera exposició fotogràfica: &quot;El valor de la solidaritat. Una mirada a La Marató de 3Cat&quot;,
                    elaborada per alumnes de l&apos;Escola de Mitjans Audiovisuals (EMAV) al voltant de 4 valors que defineixen La
                    Marató: solidaritat, emoció, confiança i esforç.
                </p>
                <p>
                    La periodista Lídia Heredia, que va presentar La Marató 2008 amb Raquel Sans, va conduir la cloenda del
                    simposi, en la qual van participar el conseller de Salut, Boi Ruiz, el president de la Corporació Catalana de
                    Mitjans Audiovisuals, Brauli Duart, i el president de l&apos;Institut d&apos;Estudis Catalans, Joandomènec
                    Ros.
                </p>
                <p>
                    Amb motiu del simpòsium, TV3 va emetre &quot;La Marató dels investigadors&quot;, un programa especial conduït
                    per Lídia Heredia i Raquel Sans, que va comptar amb la participació de testimonis de La Marató del 2008,
                    metges i investigadors en malalties mentals per explicar com ha avançat la recerca en aquests anys.
                </p>
                <h2>Resultats dels projectes finançats per La Marató 2008</h2>
                <ul>
                    <li>
                        <Enllac
                            href='//www.tv3.cat/marato/docs/simposiums/marato2014/index.html'
                            title='Resultats dels projectes finançats per La Marató 2008'
                            novaFinestra={true}
                        >
                            Resultats dels projectes finançats per La Marató 2008
                        </Enllac>
                    </li>
                </ul>
                <h2>Exposició fotogràfica</h2>
                <ul>
                    <li>
                        <Enllac
                            href='https://www.3cat.cat/tv3/marato/exposicio-fotografica/2015/390'
                            title='Exposició fotogràfica'
                            novaFinestra={true}
                        >
                            Exposició fotogràfica
                        </Enllac>
                    </li>
                </ul>
            </>
        )
    },
    '2015-comunicacio': {
        titol: 'Comunicació',
        contingut: (
            <>
                <h2>tv3.cat/marato</h2>
                <p>
                    La pàgina web de La Marató va oferir tota la informació referent al projecte al llarg de l&apos;any i va fer
                    una aposta clara pel contingut audiovisual. Durant el 2015, va registrar 208.249 visitants únics i 831.404
                    pàgines vistes. El dia de l&apos;emissió del programa, el 13 de desembre, va tenir 51.947 visitants únics, que
                    van consultar 177.733 pàgines.
                </p>
                <h2>Xarxes socials</h2>
                <p>
                    201.332 usuaris van seguir l&apos;actualitat de La Marató a través de Facebook i 46.100 a través de Twitter.
                    Instagram va guanyar 891 seguidors només el dia de La Marató i va acabar el 2015 superant els 3.500.
                </p>
                <h2>Revista</h2>
                <ul>
                    <li>
                        <Enllac
                            href='https://issuu.com/monmarato/docs/monmarato27'
                            title="Número 27, s'obre en finestra nova"
                            novaFinestra={true}
                        >
                            Número 27
                        </Enllac>
                    </li>
                </ul>
                <h2>Píndoles audiovisuals</h2>
                <p>
                    Com a novetat del 2015, la Fundació va comunicar algunes de les fites anuals del projecte de La Marató a
                    través de píndoles audiovisuals que es van difondre per TV3, xarxes socials i correus electrònics. Així, es
                    van fer píndoles per comunicar la xifra total recaptada per La Marató 2014, la celebració del simpòsium sobre
                    malalties minoritàries, el lliurament d&apos;ajudes als projectes sobre malalties del cor i l&apos;agraïment
                    pel resultat de La Marató 2015. En conjunt, aquests vídeos van tenir prop de 53.000 visualitzacions per
                    internet i xarxes socials, a més dels passis de l&apos;espot que va poder veure l&apos;audiència de TV3.
                </p>
            </>
        )
    },
    '2015-participacio': {
        titol: 'Participació ciutadana i empresarial',
        contingut: (
            <>
                <img src={`${IMG_HOST}/multimedia/jpg/9/6/1469093670569.jpg`} alt='Imatge de voluntaris' />
                <h2>Voluntaris</h2>
                <p>
                    Durant la jornada del 13 de desembre, les quatre seus telefòniques de La Marató van funcionar a ple rendiment
                    per fer possible que tot el moviment solidari arribés al marcador. Fira de Barcelona, Fira de Girona, Port de
                    Tarragona i Universitat de Lleida van acollir un miler de línies telefòniques que van canalitzar les donacions
                    dels ciutadans a La Marató. Els 2.330 voluntaris que es van mobilitzar aquell dia van ser els encarregats
                    d&apos;atendre els prop de 49.000 donatius que van arribar al telèfon 905 11 50 50.
                </p>
                <p>
                    Aquest col·lectiu va estar format per voluntaris procedents de 25 entitats de voluntariat, així com de
                    persones a títol individual, cares conegudes dels àmbits cultural, polític, esportiu i científic català i
                    professionals de TV3 i Catalunya Ràdio.
                </p>
                <h2>Altres formes de suport</h2>
                <p>
                    Els ajuntaments dels municipis catalans van renovar el seu suport a La Marató amb la penjada de pancartes als
                    carrers les setmanes prèvies al programa. També les sales i companyies teatrals es van adherir a l&apos;edició
                    2015 amb la lectura d&apos;un manifest el cap de setmana de l&apos;emissió.
                </p>
            </>
        )
    },
    '2015-projecte-pilot': {
        titol: 'Visites pilot "Visita la recerca de La Marató"',
        contingut: (
            <>
                <p>
                    El mes de juliol, la <strong>Fundació</strong> va iniciar les proves pilot d&apos;un nou projecte que posaria
                    en marxa al 2016, en motiu dels 25 anys de <strong>La Marató</strong> de TV3. Es tracta de visites als centres
                    de recerca perquè els ciutadans coneguin els projectes que està impulsant La Marató gràcies a la seva
                    solidaritat i esforç.
                </p>
                <p>
                    Es van fer de 5 visites pilot en centres de recerca de Barcelona, Girona i Sabadell. La quinzena de
                    participants de cadascuna d&apos;elles va poder conèixer com funciona el procés de la recerca i com{' '}
                    <strong>La Marató</strong> ha contribuït a avançar en el coneixement, diagnòstic i tractament de diferents
                    malalties.
                </p>
                <div className={styles.imagesRow}>
                    <img src={`${IMG_HOST}/multimedia/jpg/0/9/1469093512890.jpg`} alt='Imatge de les visites pilot' />
                    <img src={`${IMG_HOST}/multimedia/jpg/4/8/1469093638184.jpg`} alt='Imatge de les visites pilot' />
                    <img src={`${IMG_HOST}/multimedia/jpg/7/3/1469093461837.jpg`} alt='Imatge de les visites pilot' />
                    <img src={`${IMG_HOST}/multimedia/jpg/2/5/1469093587552.jpg`} alt='Imatge de les visites pilot' />
                    <img src={`${IMG_HOST}/multimedia/jpg/4/5/1469093549354.jpg`} alt='Imatge de les visites pilot' />
                </div>
            </>
        )
    },
    '2015-recerca-en-malalties-del-cor': {
        titol: 'Impuls a la recerca en malalties del cor. La Marató 2014',
        contingut: (
            <>
                <h2>Convocatòria de projectes</h2>
                <p>
                    A la convocatòria d&apos;ajudes a la recerca sobre malalties del cor que la Fundació va obrir el mes de febrer
                    de 2015 s&apos;hi van presentar 121 projectes.
                </p>
                <h2>Procés d&apos;avaluació</h2>
                <p>
                    Tots els treballs candidats van ser avaluats per 59 experts en malalties del cor d&apos;àmbit internacional en
                    un sistema d&apos;avaluació coordinat per l&apos;Agència de Qualitat i Avaluació Sanitàries de Catalunya
                    (AQUAS). La qualitat, metodologia, rellevància científica, sanitària i social, el valor innovador i la
                    viabilitat de cada projecte han estat els factors que han determinat la distribució dels fons aconseguits en
                    l&apos;edició passada de <strong>La Marató</strong> de TV3.
                </p>
                <h2>Elaboració del rànquing i decisió sobre l&apos;adjudicació d&apos;ajudes</h2>
                <p>
                    Una representació del grup d&apos;experts avaluadors es va reunir per elaborar un rànquing dels projectes més
                    ben valorats. Un cop validada aquesta llista per la Comissió Assessora Científica, el Patronat de la Fundació
                    va decidir premiar 43 projectes sobre malalties del cor.
                </p>
                <p>
                    Un total de 70 científics i els seus equips dedicaran els pròxims tres anys a avançar en el coneixement, el
                    diagnòstic i el tractament de les malalties del cor, amb uns resultats que incidiran directament en la
                    qualitat i l&apos;esperança de vida de les persones afectades. Els treballs, 22 d&apos;unitaris i 21 de
                    coordinats, es desenvoluparan en 35 centres d&apos;investigació de primera línia, i establiran xarxes de
                    recerca entre equips catalans, de l&apos;estat espanyol i d&apos;àmbit internacional. Veieu quin són els{' '}
                    <Enllac href='/tv3/marato/recerca/projectes-financats' title='projectes premiats'>
                        projectes premiats
                    </Enllac>
                </p>
                <h2>Acte de lliurament d&apos;ajudes</h2>
                <img src={`${IMG_HOST}/multimedia/jpg/5/0/1469093217405.jpg`} alt="Imatge de l'acte de lliurament d'ajudes" />
                <p>
                    Els 70 investigadors premiats van recollir els guardons en un acte celebrat el 6 de novembre del 2015 a
                    l&apos;Acadèmia de Ciències Mèdiques i de la Salut de Catalunya i de les Balears, conduït per Mònica Terribas
                    i Quim Masferrer, presentadors de l&apos;edició 2014 del programa. Hi van participar el conseller de Salut,
                    Boi Ruiz; el president de l&apos;Acadèmia de Ciències Mèdiques i de la Salut de Catalunya i de Balears, Àlvar
                    Net, el president de la Corporació Catalana de Mitjans Audiovisuals i de la Fundació La Marató de 3Cat, Brauli
                    Duart, el director de la Fundació, Lluís Bernabé i el coordinador de la Comissió Assessora Científica de la
                    Fundació, Gabriel Capellà.
                </p>
            </>
        )
    },
    '2015-reconeixements': {
        titol: 'Reconeixements',
        contingut: (
            <>
                <p>Durant el 2015, la Fundació i La Marató de 3Cat van rebre els següents guardons:</p>
                <h2>Premi Especial Autonòmic de l&apos;Acadèmia de Televisió</h2>
                <img
                    src={`${IMG_HOST}/multimedia/jpg/9/8/1469093331089.jpg`}
                    alt="Imatge de la entrega del premi Especial Autonòmic de l'Acadèmia de Televisió"
                />
                <p>
                    El Consell de l&apos;Acadèmia de les Ciències i les Arts de Televisió va atorgar un Premi Especial Autonòmic a
                    La Marató de 3Cat per ser un format televisiu únic que mobilitza des del 1992 tota la societat catalana al
                    voltant de dos objectius: sensibilitzar i recaptar fons per a la investigació biomèdica.
                </p>
                <h2>Premi Mussol 2015</h2>
                <img src={`${IMG_HOST}/multimedia/jpg/4/8/1469093372084.jpg`} alt='Imatge de la entrega del premi Mussol 2015' />
                <p>
                    L&apos;Ateneu i l&apos;Ajuntament de Sant Quirze del Vallès van lliurar el Premi Mussol 2015 a la Fundació com
                    a reconeixement a la seva capacitat de mobilització social a través d&apos;un projecte solidari com és La
                    Marató de 3Cat per promoure la recerca biomèdica en benefici de la salut i la difusió del coneixement de les
                    malalties. El premi també va ser per al Disc de La Marató, com a banda sonora de la solidaritat.
                </p>
                <h2>Premi SEN Esclerosi Múltiple</h2>
                <img
                    src={`${IMG_HOST}/multimedia/jpg/7/1/1469101160217.jpg`}
                    alt='Imatge de la entrega del premi SEN Esclerosi Múltiple'
                />
                <p>
                    La Sociedad Española de Neurología va atorgar a La Marató de 3Cat el Premi SEN Esclerosi Múltiple, en la
                    modalitat social, per l&apos;esforç de divulgar el coneixement i la defensa d&apos;aquesta malaltia que es van
                    fer durant l&apos;edició del 2013.
                </p>
            </>
        )
    },
    '2015-simposium-malalties-minoritaries': {
        titol: '16è Simpòsium. Resultats de La Marató 2009',
        contingut: (
            <>
                <img src={`${IMG_HOST}/multimedia/jpg/0/7/1469093419070.jpg`} alt='Imatge del 16è Simpòsium' />
                <p>
                    La Fundació va presentar els resultats dels 20 projectes de recerca sobre malalties minoritàries impulsats amb
                    fons de La Marató 2009 en el marc del 16è Simpòsium, celebrat el 9 de juny a l&apos;Institut d&apos;Estudis
                    Catalans.
                </p>
                <p>
                    Els científics que havien dut a terme les investigacions finançades per La Marató 2009 van exposar en aquesta
                    jornada científica els avenços assolits en el coneixement, el diagnòstic i el tractament de les malalties
                    minoritàries.
                </p>
                <p>
                    La cloenda de l&apos;acte va anar a càrrec de la secretària general de Salut, Roser Fernández; el president de
                    la Corporació Catalana de Mitjans Audiovisuals i de la Fundació La Marató de 3Cat, Brauli Duart, i del
                    president de l&apos;Institut d&apos;Estudis Catalans, Joandomènec Ros.
                </p>
                <p>
                    Amb l&apos;objectiu d&apos;acostar la ciència i els resultats obtinguts a la ciutadania, el simpòsium va
                    acollir diverses activitats artístiques i de divulgació social. Música i art van acompanyar la jornada
                    científica: la cantant de jazz Zazu, de l&apos;Escola Superior de Música de Catalunya, va interpretar algunes
                    peces del disc de La Marató 2009, versionades per ella mateixa i l&apos;artista plàstic Pol Borràs va elaborar
                    en directe una obra que convidava a reflexionar sobre les malalties minoritàries.
                </p>
                <p>
                    TV3 va emetre un programa especial, titulat &quot;Malalties minoritàries. La Marató dels investigadors&quot;
                    conduït per Josep Cuní, presentador de La Marató 2009, que va recollir alguns dels projectes de recerca
                    finançats amb aquella Marató i dels avenços que han assolit.
                </p>
                <h2>Resultats dels projectes finançats per La Marató 2009</h2>
                <ul>
                    <li>
                        <Enllac
                            href='//www.tv3.cat/marato/docs/simposiums/marato2015/index.html'
                            title='Resultats dels projectes finançats per La Marató 2009'
                            novaFinestra={true}
                        >
                            Resultats dels projectes finançats per La Marató 2009
                        </Enllac>
                    </li>
                </ul>
            </>
        )
    }
};

export default function MemoriaMaratoSubpagina({ anyMarato, seccio }: Readonly<MemoriaMaratoSubpaginaProps>) {
    const key = `${anyMarato}-${seccio}`;
    const page = CONTENT[key];
    const urlFundacio = '/tv3/marato/fundacio/';

    if (!page) return null;

    return (
        <div className={styles.wrapper}>
            <TornaEnrere path={`${urlFundacio}publicacions/`} text={`Totes les memòries`} />
            <TornaEnrere path={`${urlFundacio}memoria-${anyMarato}/`} text={`Memòria ${anyMarato}`} />
            <h1 className={styles.titol}>{page.titol}</h1>
            <div className={styles.contingut}>{page.contingut}</div>
        </div>
    );
}
